import { render, staticRenderFns } from "./EditRemarksModal.vue?vue&type=template&id=11782a70&"
import script from "./EditRemarksModal.vue?vue&type=script&lang=js&"
export * from "./EditRemarksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports